/**
 * RecoveryTrac.WebApi | v1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpContext 
        }       from '@angular/common/http';
import { Observable }                                        from 'rxjs';
import { OpenApiHttpParams, QueryParamStyle } from '../query.params';

// @ts-ignore
import { BadGateway } from '../model/badGateway';
// @ts-ignore
import { Conflict } from '../model/conflict';
// @ts-ignore
import { NotFound } from '../model/notFound';
// @ts-ignore
import { SearchQueryOfTimeRecordCommentSearchV3Response } from '../model/searchQueryOfTimeRecordCommentSearchV3Response';
// @ts-ignore
import { SearchQueryOfTimeRecordSearchV3Response } from '../model/searchQueryOfTimeRecordSearchV3Response';
// @ts-ignore
import { SearchQueryOfTimeRecordTagDefinitionSearchV3Response } from '../model/searchQueryOfTimeRecordTagDefinitionSearchV3Response';
// @ts-ignore
import { SearchQueryOfTimeRecordTagSearchV3Response } from '../model/searchQueryOfTimeRecordTagSearchV3Response';
// @ts-ignore
import { SearchResultOfTimeRecordCommentSearchV3Response } from '../model/searchResultOfTimeRecordCommentSearchV3Response';
// @ts-ignore
import { SearchResultOfTimeRecordSearchV3Response } from '../model/searchResultOfTimeRecordSearchV3Response';
// @ts-ignore
import { SearchResultOfTimeRecordTagDefinitionSearchV3Response } from '../model/searchResultOfTimeRecordTagDefinitionSearchV3Response';
// @ts-ignore
import { SearchResultOfTimeRecordTagSearchV3Response } from '../model/searchResultOfTimeRecordTagSearchV3Response';
// @ts-ignore
import { TimeRecordCapabilitiesV3Response } from '../model/timeRecordCapabilitiesV3Response';
// @ts-ignore
import { TimeRecordCommentCapabilitiesV3Response } from '../model/timeRecordCommentCapabilitiesV3Response';
// @ts-ignore
import { TimeRecordCommentCreateV3CmdBody } from '../model/timeRecordCommentCreateV3CmdBody';
// @ts-ignore
import { TimeRecordCommentCreateV3Response } from '../model/timeRecordCommentCreateV3Response';
// @ts-ignore
import { TimeRecordTagCapabilitiesV3Response } from '../model/timeRecordTagCapabilitiesV3Response';
// @ts-ignore
import { TimeRecordTagCreateV3CmdBody } from '../model/timeRecordTagCreateV3CmdBody';
// @ts-ignore
import { TimeRecordTagCreateV3Response } from '../model/timeRecordTagCreateV3Response';
// @ts-ignore
import { Unauthorized } from '../model/unauthorized';
// @ts-ignore
import { ValidationResultDetails } from '../model/validationResultDetails';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';



@Injectable({
  providedIn: 'root'
})
export class TimeRecordService extends BaseService {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * Get time record search capabilities
     * Determines user\&#39;s access level for Time Record Search V3.             Returns Self (own records), Normal (Time Manager or Personal Team owner), or Elevated (admin roles).
     * @endpoint get /api/v3/time-record/capabilities/v3
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public apiV3TimeRecordCapabilitiesV3Get(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<TimeRecordCapabilitiesV3Response>;
    public apiV3TimeRecordCapabilitiesV3Get(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<TimeRecordCapabilitiesV3Response>>;
    public apiV3TimeRecordCapabilitiesV3Get(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<TimeRecordCapabilitiesV3Response>>;
    public apiV3TimeRecordCapabilitiesV3Get(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {

        let localVarHeaders = this.defaultHeaders;

        // authentication (Bearer) required
        localVarHeaders = this.configuration.addCredentialToHeaders('Bearer', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v3/time-record/capabilities/v3`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<TimeRecordCapabilitiesV3Response>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * TimeRecord_Comment_Run
     * @endpoint get /api/v3/time-record-comment/capabilities/v3
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public apiV3TimeRecordCommentCapabilitiesV3Get(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<TimeRecordCommentCapabilitiesV3Response>;
    public apiV3TimeRecordCommentCapabilitiesV3Get(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<TimeRecordCommentCapabilitiesV3Response>>;
    public apiV3TimeRecordCommentCapabilitiesV3Get(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<TimeRecordCommentCapabilitiesV3Response>>;
    public apiV3TimeRecordCommentCapabilitiesV3Get(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {

        let localVarHeaders = this.defaultHeaders;

        // authentication (Bearer) required
        localVarHeaders = this.configuration.addCredentialToHeaders('Bearer', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v3/time-record-comment/capabilities/v3`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<TimeRecordCommentCapabilitiesV3Response>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Search time record comments
     * Returns paginated search results for time record comments, including the author\&#39;s name.             Normal users see only comments on their own time records; elevated roles see all.
     * @endpoint get /api/v3/time-record-comment
     * @param query 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public apiV3TimeRecordCommentGet(query?: SearchQueryOfTimeRecordCommentSearchV3Response, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<SearchResultOfTimeRecordCommentSearchV3Response>;
    public apiV3TimeRecordCommentGet(query?: SearchQueryOfTimeRecordCommentSearchV3Response, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<SearchResultOfTimeRecordCommentSearchV3Response>>;
    public apiV3TimeRecordCommentGet(query?: SearchQueryOfTimeRecordCommentSearchV3Response, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<SearchResultOfTimeRecordCommentSearchV3Response>>;
    public apiV3TimeRecordCommentGet(query?: SearchQueryOfTimeRecordCommentSearchV3Response, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {

        let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'query',
            <any>query,
            QueryParamStyle.Json,
            false,
        );


        let localVarHeaders = this.defaultHeaders;

        // authentication (Bearer) required
        localVarHeaders = this.configuration.addCredentialToHeaders('Bearer', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v3/time-record-comment`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<SearchResultOfTimeRecordCommentSearchV3Response>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters.toHttpParams(),
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Search time records
     * Returns paginated search results for Time Records (individual time blocks).             Includes denormalized user/project/task/labor category fields and three status dimensions.             Results are scoped by access level: elevated users see all time records, Time Managers see records for managed projects,             Personal Team owners see records for team members across all projects, and standard users see only their own.
     * @endpoint get /api/v3/time-record
     * @param query 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public apiV3TimeRecordGet(query?: SearchQueryOfTimeRecordSearchV3Response, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<SearchResultOfTimeRecordSearchV3Response>;
    public apiV3TimeRecordGet(query?: SearchQueryOfTimeRecordSearchV3Response, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<SearchResultOfTimeRecordSearchV3Response>>;
    public apiV3TimeRecordGet(query?: SearchQueryOfTimeRecordSearchV3Response, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<SearchResultOfTimeRecordSearchV3Response>>;
    public apiV3TimeRecordGet(query?: SearchQueryOfTimeRecordSearchV3Response, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {

        let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'query',
            <any>query,
            QueryParamStyle.Json,
            false,
        );


        let localVarHeaders = this.defaultHeaders;

        // authentication (Bearer) required
        localVarHeaders = this.configuration.addCredentialToHeaders('Bearer', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v3/time-record`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<SearchResultOfTimeRecordSearchV3Response>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters.toHttpParams(),
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * TimeRecord_Tag_Run
     * @endpoint get /api/v3/time-record-tag/capabilities/v3
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public apiV3TimeRecordTagCapabilitiesV3Get(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<TimeRecordTagCapabilitiesV3Response>;
    public apiV3TimeRecordTagCapabilitiesV3Get(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<TimeRecordTagCapabilitiesV3Response>>;
    public apiV3TimeRecordTagCapabilitiesV3Get(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<TimeRecordTagCapabilitiesV3Response>>;
    public apiV3TimeRecordTagCapabilitiesV3Get(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {

        let localVarHeaders = this.defaultHeaders;

        // authentication (Bearer) required
        localVarHeaders = this.configuration.addCredentialToHeaders('Bearer', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v3/time-record-tag/capabilities/v3`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<TimeRecordTagCapabilitiesV3Response>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Search time record tag definitions
     * Returns paginated search results for time record tag definitions.             All active users can search definitions; no per-user scoping is applied.
     * @endpoint get /api/v3/time-record-tag-definition
     * @param query 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public apiV3TimeRecordTagDefinitionGet(query?: SearchQueryOfTimeRecordTagDefinitionSearchV3Response, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<SearchResultOfTimeRecordTagDefinitionSearchV3Response>;
    public apiV3TimeRecordTagDefinitionGet(query?: SearchQueryOfTimeRecordTagDefinitionSearchV3Response, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<SearchResultOfTimeRecordTagDefinitionSearchV3Response>>;
    public apiV3TimeRecordTagDefinitionGet(query?: SearchQueryOfTimeRecordTagDefinitionSearchV3Response, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<SearchResultOfTimeRecordTagDefinitionSearchV3Response>>;
    public apiV3TimeRecordTagDefinitionGet(query?: SearchQueryOfTimeRecordTagDefinitionSearchV3Response, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {

        let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'query',
            <any>query,
            QueryParamStyle.Json,
            false,
        );


        let localVarHeaders = this.defaultHeaders;

        // authentication (Bearer) required
        localVarHeaders = this.configuration.addCredentialToHeaders('Bearer', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v3/time-record-tag-definition`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<SearchResultOfTimeRecordTagDefinitionSearchV3Response>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters.toHttpParams(),
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Search time record tags
     * Returns paginated search results for time record tag assignments, including tag definition details.             Normal users see only tags for their own time records; elevated roles see all.
     * @endpoint get /api/v3/time-record-tag
     * @param query 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public apiV3TimeRecordTagGet(query?: SearchQueryOfTimeRecordTagSearchV3Response, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<SearchResultOfTimeRecordTagSearchV3Response>;
    public apiV3TimeRecordTagGet(query?: SearchQueryOfTimeRecordTagSearchV3Response, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<SearchResultOfTimeRecordTagSearchV3Response>>;
    public apiV3TimeRecordTagGet(query?: SearchQueryOfTimeRecordTagSearchV3Response, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<SearchResultOfTimeRecordTagSearchV3Response>>;
    public apiV3TimeRecordTagGet(query?: SearchQueryOfTimeRecordTagSearchV3Response, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {

        let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'query',
            <any>query,
            QueryParamStyle.Json,
            false,
        );


        let localVarHeaders = this.defaultHeaders;

        // authentication (Bearer) required
        localVarHeaders = this.configuration.addCredentialToHeaders('Bearer', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v3/time-record-tag`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<SearchResultOfTimeRecordTagSearchV3Response>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters.toHttpParams(),
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Create a time record comment
     * Creates a new comment on a time record. Comments are immutable once created. Only elevated roles (FieldSupervisor, RegionalManager, ProjectManager, OperationsManager, PortalAdministrator) may comment on time records. The time record owner may not comment on their own records.
     * @endpoint post /api/v3/time-record/{timeRecordId}/comments
     * @param timeRecordId 
     * @param timeRecordCommentCreateV3CmdBody 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public apiV3TimeRecordTimeRecordIdCommentsPost(timeRecordId: number, timeRecordCommentCreateV3CmdBody: TimeRecordCommentCreateV3CmdBody, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<TimeRecordCommentCreateV3Response>;
    public apiV3TimeRecordTimeRecordIdCommentsPost(timeRecordId: number, timeRecordCommentCreateV3CmdBody: TimeRecordCommentCreateV3CmdBody, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<TimeRecordCommentCreateV3Response>>;
    public apiV3TimeRecordTimeRecordIdCommentsPost(timeRecordId: number, timeRecordCommentCreateV3CmdBody: TimeRecordCommentCreateV3CmdBody, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<TimeRecordCommentCreateV3Response>>;
    public apiV3TimeRecordTimeRecordIdCommentsPost(timeRecordId: number, timeRecordCommentCreateV3CmdBody: TimeRecordCommentCreateV3CmdBody, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (timeRecordId === null || timeRecordId === undefined) {
            throw new Error('Required parameter timeRecordId was null or undefined when calling apiV3TimeRecordTimeRecordIdCommentsPost.');
        }
        if (timeRecordCommentCreateV3CmdBody === null || timeRecordCommentCreateV3CmdBody === undefined) {
            throw new Error('Required parameter timeRecordCommentCreateV3CmdBody was null or undefined when calling apiV3TimeRecordTimeRecordIdCommentsPost.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (Bearer) required
        localVarHeaders = this.configuration.addCredentialToHeaders('Bearer', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v3/time-record/${this.configuration.encodeParam({name: "timeRecordId", value: timeRecordId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int32"})}/comments`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<TimeRecordCommentCreateV3Response>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: timeRecordCommentCreateV3CmdBody,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Assign a tag to a time record
     * Assigns a tag to a time record. Validates that the tag definition exists and is not deleted. Any active user may assign tags to their own time records; elevated roles may assign to any time record.
     * @endpoint post /api/v3/time-record/{timeRecordId}/tags
     * @param timeRecordId 
     * @param timeRecordTagCreateV3CmdBody 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public apiV3TimeRecordTimeRecordIdTagsPost(timeRecordId: number, timeRecordTagCreateV3CmdBody: TimeRecordTagCreateV3CmdBody, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<TimeRecordTagCreateV3Response>;
    public apiV3TimeRecordTimeRecordIdTagsPost(timeRecordId: number, timeRecordTagCreateV3CmdBody: TimeRecordTagCreateV3CmdBody, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<TimeRecordTagCreateV3Response>>;
    public apiV3TimeRecordTimeRecordIdTagsPost(timeRecordId: number, timeRecordTagCreateV3CmdBody: TimeRecordTagCreateV3CmdBody, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<TimeRecordTagCreateV3Response>>;
    public apiV3TimeRecordTimeRecordIdTagsPost(timeRecordId: number, timeRecordTagCreateV3CmdBody: TimeRecordTagCreateV3CmdBody, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (timeRecordId === null || timeRecordId === undefined) {
            throw new Error('Required parameter timeRecordId was null or undefined when calling apiV3TimeRecordTimeRecordIdTagsPost.');
        }
        if (timeRecordTagCreateV3CmdBody === null || timeRecordTagCreateV3CmdBody === undefined) {
            throw new Error('Required parameter timeRecordTagCreateV3CmdBody was null or undefined when calling apiV3TimeRecordTimeRecordIdTagsPost.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (Bearer) required
        localVarHeaders = this.configuration.addCredentialToHeaders('Bearer', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v3/time-record/${this.configuration.encodeParam({name: "timeRecordId", value: timeRecordId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int32"})}/tags`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<TimeRecordTagCreateV3Response>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: timeRecordTagCreateV3CmdBody,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

}
